import { BaseService } from 'core/services';
import LocalDoctorRouteService from './LocalDoctorRouteService';

class LocalDoctorService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new LocalDoctorRouteService());
    }

    async sync(){
        const url = this.routeService.sync();
        const response = await this.apiClient.put(url);
        return response.data || null;
    }

    async nikoSync(){
        const url = this.routeService.nikoSync();
        const response = await this.apiClient.put(url);
        return response.data || null;
    }
}

export default LocalDoctorService;
